import React, { useRef } from 'react'
import { Container } from 'reactstrap'

import { useDashboardRedux } from '@hooks'
import MenuItem from './MenuItem'
import './MenuList.css'

const MenuList = () => {
    const { filteredMenus, setSelectedProduct } = useDashboardRedux()
    const sectionRefs = useRef({})

    const onSelectProduct = product => {
        setSelectedProduct(product)
    }

    return (
        <Container className="menu-container">
            {filteredMenus.map(section => (
                <div
                    key={`${section.category}-${section.stallId}`}
                    ref={el => (sectionRefs.current[section.category] = el)}
                    data-category={section.category}
                    data-stall-id={section.stallId}
                    className="menu-section"
                >
                    <h2 className="menu-section-header">{section.category}</h2>
                    {section.items.map((item, idx) => {
                        return <MenuItem key={idx} item={item} onSelectProduct={onSelectProduct} />
                    })}
                </div>
            ))}
        </Container>
    )
}

export default MenuList
